import { Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import homePageMenuItem from "../../../../utilities/pictures/homePageMenuItem";
import NavPills from "../../../public/slider/NavPills";
import style from "./first.module.css";

export default function FirstSegment() {
  return (
    <>
      <NavPills />
      <Container
        className={
          "d-flex justify-content-center flex-wrap gap-3 " + style.containter
        }
      >
        {homePageMenuItem.map((item, idx) => (
          <Link
            to={item.url}
            key={idx}
            className="text-decoration-none text-dark"
          >
            <article className={style.icon} key={item.id}>
              <img src={item.mainSrc} />
              {/* <p>{item.title}</p> */}
            </article>
          </Link>
        ))}
      </Container>
    </>
  );
}
